import Link from 'next/link'
import { twMerge } from 'tailwind-merge'
import { isWsAssistant } from 'shared/hooks/use-user'
import { isWsAdmin } from 'shared/hooks/use-user'
import { isDomainOwner } from 'shared/hooks/use-user'
import useUser from 'shared/hooks/use-user'
import { TopicInterface } from 'modules/community/types/topic-interface'
import { TopicMenu } from './topic-menu'

interface TopicItemProps {
  topic: TopicInterface
  isSelected: boolean
  communityPath: string
  onEdit: (topic: TopicInterface) => void
  onDelete: (topicId: number) => void
}

export const TopicItem = ({
  topic,
  isSelected,
  communityPath,
  onEdit,
  onDelete,
}: TopicItemProps) => {
  const { user } = useUser()

  if (!user) return null

  const canManageTopics = isDomainOwner(user) || isWsAdmin(user) || isWsAssistant(user)

  return (
    <>
      <Link
        className={twMerge(
          'min-w-0 flex-1 overflow-hidden text-ellipsis',
          isSelected && 'text-blue',
        )}
        shallow
        href={`/community/${communityPath}/${topic.path}`}
      >
        #{topic.name}
      </Link>
      {canManageTopics && <TopicMenu topic={topic} onEdit={onEdit} onDelete={onDelete} />}
    </>
  )
}
